import { httpClient } from "src/shared/services/httpClient";

export const getCompanySuspensions = () =>
  httpClient.get("/companySuspension/listOfSuspensions");
